import React, { useEffect } from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import { Link } from "react-router-dom";
import {
  AiOutlineArrowLeft,
  AiOutlineArrowRight,
  AiOutlineShareAlt,
} from "react-icons/ai";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const izbNewsSlider1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public-1.jpg";

const izbNewsSlider2 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo-Zambia-Bank-to-Fund-Prospective-Home-1.jpg";

const izbNewsSlider3 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/INDO-ZAMBIA-BANK-AND-ZAMBIA-AIR-FORCE.jpg";

const izbNewsSlider4 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-agreement-frontclear.png";

const izbNewsSlider5 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Indo-Zambia-Bank-COP29.png";

const izbNewsSlider6 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/IZB@40-1.jpg";

const izbNewsSlider7 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/celebrating-zambia-s-diamond-jubilee-of-independence-1.jpg";

const izbNewsSlider8 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-partners-with-action-new-mod-4.jpg";

const izbNewsSlider9 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/zambia-financial-literacy-week-2025.png";

const izbNewsSlider10 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-40th-annual-general-meeting-5.png";

const izbNewsSlider11 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/coffee-and-cars-banner-3.jpg";

const izbNewsSlider12 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz-4.jpeg";

const izbNewsSlider13 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024-banner-1.png";

const izbNewsSlider14 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/branch-tour-of-international-school-of-lusaka-at-our-corporate-head-office-banner.png";

const izbNewsSlider15 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-and-zaffico-sign-k200-million-funding-agreement-banner-1.jpeg";

const izbNewsSlider16 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-stand-at-the-97th-agricultural-commercial-show-banner.jpg";

const izbNewsSlider17 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/supporting-chembe-future-with-youth-women-empowerment-thumb.png";

const izbNewsSlider18 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/empowering-communities-with-cdf-loans-thumb.png";

const izbNewsSlider19 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-hands-over-constituency-development-funds-in-solwezi-thumb.png";

const izbNewsSlider20 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-supports-chawama-constituency-development-thumb.png";

// 
const izbNewsSlider21 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-commits-k665-million-to-zescos-green-energy-initiative-in-chadiza-thumb.jpg"

const izbNewsSlider22 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget-thumb.jpg"

const izbNewsSlider23 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/idc-intra-group-market-place-thumb.jpg"

const izbNewsSlider24 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance-thumb.jpg"

const izbNewsSlider25 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/the-italian-school-of-lusakas-educational-tour-of-indo-house-our-corporate-head-office-thumb.jpg"

const izbNewsSlider26 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-2025-thumb.jpg"

const izbNewsSlider27 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo-thumb.jpg"

const izbNewsSlider28 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/izb-southern-province-mou-for-farmer-loans-thumb.jpg"

const izbNewsSlider29 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/ba-kopala-celebrating-endurance-community-and-a-spirit-of-togetherness-by-being-official-platinum-sponsor-of-2025-zaffico-marathon-thumb.webp"

const izbNewsSlider30 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-partners-with-zambia-airways-to-elevate-premier-banking-experience-thumb.webp"

const izbNewsSlider31 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia-thumb.webp";

const izbNewsSlider32 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital-thumb.jpg"

const izbNewsSlider33 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-zambia-bank-csr-medical-equipment-thumb.jpg"


// 
const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";

const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

const LatestNews = () => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/BackgroundBrundcrumb.png";
  const career = "https://izbassetsmain.blob.core.windows.net/izbwebassets/EMPLOYMENT AND CAREER DEVELOPMENT OPPORTUNITIES-Thumbnail.png";
  const customerNotice = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Thumbnail-Customer Notice.png";
  const customerNotice1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Customer_Notice_1-thumbnail.png";
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])



  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <img
        src={ArrowLeft}
        className={className}
        style={{
          ...style,
          display: "block",
          width: "50px",
          height: "50px",
          left: "-58px",
          zIndex: "99"
        }}
        onClick={onClick}
      />
    );
  }

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <img
        src={ArrowRight}
        className={className}

        onClick={onClick}
      />
    );
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };


  return (
    <>
      <Breadcrumb Heading="Latest News" img={BackgroundBrundcrumb} />

      <section className="latest-news pb-4 news-slider-sub">
        <div className="container">
          <div className="row">
            <div className="container">
              <div className="heading py-3">
                <h1 className="text-center pt-4">Latest News</h1>
                <p className="text-center pb-4">All News And Updates</p>
              </div>

            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://youtu.be/7HwteoItStI" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider33} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="https://youtu.be/7HwteoItStI" target="_blank" style={{ textTransform: "none" }}>
                      Indo Zambia Bank – Landmark CSR Project, delivers...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>November 18, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank has reaffirmed its commitment to national development through major CSR investments in the health sector. With donations totaling over K1.9 million, we equipped the Zambia Flying Doctor Service...
                  </p>
                  <a href="https://youtu.be/7HwteoItStI" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider32} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital" style={{ textTransform: "none" }}>
                      Indo Zambia Bank officially hands over essential...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>November 17, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank proudly reaffirmed its commitment to healthcare by officially handing over essential medical equipment to the Ministry of Health at Ndola Teaching Hospital (NTH) valued at over ZMW 422,000...
                  </p>
                  <a href="/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider31} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia" style={{ textTransform: "none" }}>
                      Indo Zambia Bank proudly reaffirmed its commitment...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>November 15, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank is proud to have officially handed over a fully furbished and equipped state-of-the-art Theatre unit and Dental unit, valued at over ZMW 1 million, to The Ministry of Health at The Zambia Flying Doctors...
                  </p>
                  <a href="/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-partners-with-zambia-airways-to-elevate-premier-banking-experience">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider30} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-partners-with-zambia-airways-to-elevate-premier-banking-experience" style={{ textTransform: "none" }}>
                      Indo Zambia Bank Partners with Zambia Airways to...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>November 12, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank has signed a Memorandum of Understanding with Zambia Airways, introducing exclusive flight discounts for Premier Banking customers across all routes. The partnership aims to enhance...
                  </p>
                  <a href="/indo-zambia-bank-partners-with-zambia-airways-to-elevate-premier-banking-experience">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/ba-kopala-platinum-sponsor-2025-zaffico-marathon">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider29} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/ba-kopala-platinum-sponsor-2025-zaffico-marathon" style={{ textTransform: "none" }}>
                      Ba Kopala! Celebrating endurance, community and...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>November 09, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank is proud to have been the Platinum Sponsor of the 2025 ZAFFICO Marathon held in Ndola. The event brought together over 1,000 runners from across the country in a celebration of fitness...
                  </p>
                  <a href="/ba-kopala-platinum-sponsor-2025-zaffico-marathon">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/izb-southern-province-mou-for-farmer-loans">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider28} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/izb-southern-province-mou-for-farmer-loans" style={{ textTransform: "none" }}>
                      Indo Zambia Bank signed a Memorandum of...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>October 16, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    During Day two of the Southern Province Expo 2025, our Managing Director, Mr. Brajesh Kumar Singh, participated in a panel discussion themed “Climate Smart Agriculture and Livestock Value Chain.”
                  </p>
                  <a href="/izb-southern-province-mou-for-farmer-loans">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider27} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo" style={{ textTransform: "none" }}>
                      Indo Zambia Bank Exhibits at the 2025 Southern Province...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>October 15, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank was honoured to be a Bronze Sponsor and participant at the Southern Province Expo 2025, held in Livingstone under the theme “Unlocking Investment Opportunities for Socio-Economic Transformation...
                  </p>
                  <a href="/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-2025">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider26} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-2025" style={{ textTransform: "none" }}>
                      Indo Zambia Bank proudly participated in the inaugural...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>October 14, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Last week, Indo Zambia Bank proudly participated in the inaugural Higher Education Indaba 2025 held in Livingstone, organized by the Higher Education Authority and officiated by The Minister of Education...
                  </p>
                  <a href="/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-2025">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/the-italian-school-of-lusakas-educational-tour-of-indo-house-our-corporate-head-office">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider25} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/the-italian-school-of-lusakas-educational-tour-of-indo-house-our-corporate-head-office" style={{ textTransform: "none" }}>
                      The Italian School of Lusaka's educational tour of Indo...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>October 10, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    As part of Customer Service Week, Indo Zambia Bank was delighted to host pupils from The Italian School Of Lusaka for an educational tour of Indo House, our Corporate Head Office. The visit provided the pupils with valuable...
                  </p>
                  <a href="/the-italian-school-of-lusakas-educational-tour-of-indo-house-our-corporate-head-office">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider24} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance" style={{ textTransform: "none" }}>
                      IZB launches Indo Dairy Production Finance Scheme...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>October 4, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank (IZB) has launched the Indo Dairy Production Finance Scheme and Indo Dairy Development Finance Scheme in Magoye, Southern Province.
                    Southern Province Permanent Secretary...
                  </p>
                  <a href="/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/idc-intra-group-market-place">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider23} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/idc-intra-group-market-place" style={{ textTransform: "none" }}>
                      IDC Intra Group Market Place! <br />
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>October 2, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank proudly participated in the Industrial Development Corporation (IDC) Intergroup Marketplace, held on 1st October 2025 at the Mulungushi International Conference Centre.
                  </p>
                  <a href="/idc-intra-group-market-place">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider22} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget" style={{ textTransform: "none" }}>
                      IZB and MOFNP partner to host the National...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>September 29, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank (IZB) Managing Director, Mr. Brajesh Kumar Singh, has reaffirmed the Bank’s unwavering commitment to Zambia’s economic growth and development, speaking during his opening remarks at the National...

                  </p>
                  <a href="/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-commits-k665-million-to-zescos-green-energy-initiative-in-chadiza">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider21} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-commits-k665-million-to-zescos-green-energy-initiative-in-chadiza" style={{ textTransform: "none" }}>
                      Indo Zambia Bank Commits K66.5 Million to ZESCO’s...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>September 24, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank (IZB) and @zesco.zm Limited have signed a landmark K66.5 million Facility Agreement under the Bank of Zambia’s Stability and Resilience Facility (SRF), marking a crucial step in strengthening Zambia’s...

                  </p>
                  <a href="/indo-zambia-bank-commits-k665-million-to-zescos-green-energy-initiative-in-chadiza">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>
            {/*  */}

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/empowering-communities-with-cdf-loans">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider18} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/empowering-communities-with-cdf-loans" style={{ textTransform: "none" }}>
                      Empowering Communities with CDF Loans
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>August 8, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank proudly handed over Constituency Development Fund loans to beneficiaries in Milenge Constituency. This support will help local entrepreneurs and communities grow, create...
                  </p>
                  <a href="/empowering-communities-with-cdf-loans">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://www.youtube.com/watch?v=yhg1fBLQTOs" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider16} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="https://www.youtube.com/watch?v=yhg1fBLQTOs" target="_blank" style={{ textTransform: "none" }}>
                      Indo Zambia Bank stand at the 97th Agricultural...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>August 06, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    In case you missed it, our stand coverage of the 97th Agricultural and Commerical show.<br /><br /><br /><br />
                  </p>
                  <a href="https://www.youtube.com/watch?v=yhg1fBLQTOs" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/supporting-chembe-future-with-youth-women-empowerment">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider17} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/supporting-chembe-future-with-youth-women-empowerment" style={{ textTransform: "none" }}>
                      Supporting Chembe’s Future with Youth & Women...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>July 31, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    On 31st July 2025, Indo Zambia Bank proudly handed over the Chembe Youth, Women, and Empowerment Grant to deserving beneficiaries. This initiative fuels entrepreneurship, strengthens communities...
                  </p>
                  <a href="/supporting-chembe-future-with-youth-women-empowerment">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-and-zaffico-sign-k200-million-funding-agreement">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider15} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-and-zaffico-sign-k200-million-funding-agreement" style={{ textTransform: "none" }}>
                      Indo Zambia Bank and Zaffico Sign K200 Million...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>June 26, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Yesterday, Indo Zambia Bank and the Zambia Forestry and Forest Industries Corporation (ZAFFICO) signed a landmark K200 million funding agreement under the Bank of Zambia’s Stability and Resilience...
                  </p>
                  <a href="/indo-zambia-bank-and-zaffico-sign-k200-million-funding-agreement">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/izb-hands-over-constituency-development-funds-in-solwezi">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider19} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/izb-hands-over-constituency-development-funds-in-solwezi" style={{ textTransform: "none" }}>
                      IZB Hands Over Constituency Development Funds...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>June 11, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    On 11th June 2025, Indo Zambia Bank proudly handed over Constituency Development Funds (CDF) to beneficiaries under the Solwezi Council. This initiative is part of our commitment to Supporting You...
                  </p>
                  <a href="/izb-hands-over-constituency-development-funds-in-solwezi">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/branch-tour-of-international-school-of-lusaka-at-our-corporate-head-office">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider14} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/branch-tour-of-international-school-of-lusaka-at-our-corporate-head-office" style={{ textTransform: "none" }}>
                      Branch tour of International School of Lusaka...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>May 19, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    At Indo Zambia Bank, we do not just offer banking, we empower financial futures. We were delighted to host Year Four pupils from the International School of Lusaka at our Corporate Head Office...
                  </p>
                  <a href="/branch-tour-of-international-school-of-lusaka-at-our-corporate-head-office">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider13} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024" style={{ textTransform: "none" }}>
                      Indo Zambia Bank is proud to be awarded Best Customer...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>May 13, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    This past Friday, we were honoured to attend the 28th Annual Zambia Institute of Marketing Excellence Conference and Awards Gala Dinner held in Livingstone. At the same event, Indo Zambia Bank was awarded...
                  </p>
                  <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider12} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz" style={{ textTransform: "none" }}>
                      Indo Zambia Bank Signs a (MoU) with the (DAZ)
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>April 23, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank is pleased to announce the signing of a Memorandum of Understanding (MoU) with the Dairy Association of Zambia (DAZ) for the provision of loan facilities to its members. Through this....
                  </p>
                  <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider11} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                      Coffee & Cars with Indo Zambia Bank, in partnership...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>April 14, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    This past weekend we partnered with Southern Cross Motors for an unforgettable Coffee & Cars experience! Guests had the unique opportunity to test drive some of the world’s finest motor vehicle brands...
                  </p>
                  <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="https://www.youtube.com/watch?v=WFhRVyp-Z2U" target="_blank">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider9} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="https://www.youtube.com/watch?v=WFhRVyp-Z2U" target="_blank">
                      Zambia Financial Literacy Week 2025
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>April 01, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    This year, we took financial literacy beyond banking, reaching communities across all 10 provinces of Zambia.
                    At Indo Zambia Bank, we believe that financial literacy is the key to a brighter future.
                  </p>
                  <a href="https://www.youtube.com/watch?v=WFhRVyp-Z2U" target="_blank">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/izb-40th-annual-general-meeting">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider10} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/izb-40th-annual-general-meeting">
                      IZB 40th Annual General Meeting
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>April 01, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Last Friday, the bank held its 40th Annual General Meeting, followed by a press briefing where our Board Chairman, Dr. Michael Gondwe, shared highlights of the Bank’s 2024 financial performance...
                  </p>
                  <a href="/izb-40th-annual-general-meeting">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider8} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options">
                      Indo Zambia Bank Partners with Action Auto...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>March 03, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank is pleased to announce a strategic partnership with Action Auto Zambia Limited, an authorized Isuzu vehicles dealer. This collaboration extends the Indo Vehicle Finance program to the general...
                  </p>
                  <a href="/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider1} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public">
                      Indo Zambia Bank And Southern Cross Motors...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>Jan 29, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>

                    Indo Zambia Bank has partnered with @southerncrossmotors to provide motor vehicle financing to the general public through a Memorandum of Understanding signed yesterday...
                  </p>
                  <a href="/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider2} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development">
                      Indo Zambia Bank To Fund Prospective Home...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>Jan 27, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    On 20th January 2025, Indo Zambia Bank (IZB) signed a memorandum of understanding with The Hills Property Development to revolutionise homeownership opportunities in zambia. Through this...
                  </p>
                  <a href="/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider3} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships">
                      Indo Zambia Bank And Zambia Air Force...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>Jan 21, 2025</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>

                    On 20th January 2025, Indo Zambia Bank Managing Director, Mr. Brajesh Kumar Singh accompanied by the General Manager Mr. Godwin C. Ngoma and his delegation...
                  </p>
                  <a href="/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-has-signed-an-agreement-with-frontclear">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider4} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-has-signed-an-agreement-with-frontclear">
                      Indo Zambia Bank has signed an agreement...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>November 29, 2024</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Recognizing that Money Markets are central to the functioning of financial systems, Indo Zambia Bank has signed an agreement with Frontclear enabling the Bank to participate...
                  </p>
                  <a href="/indo-zambia-bank-has-signed-an-agreement-with-frontclear">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-is-here-at-cop29">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider5} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-is-here-at-cop29">
                      Indo Zambia Bank is here at COP29!
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>November 13, 2024</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    Indo Zambia Bank was proud to attend the COP29 UN Climate Change Conference in Baku, Azerbaijan. Staying at the forefront of climate action, we are committed to innovative ...
                  </p>
                  <a href="/indo-zambia-bank-is-here-at-cop29">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/celebrating-zambia-s-diamond-jubilee-of-independence">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider7} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/celebrating-zambia-s-diamond-jubilee-of-independence">
                      Celebrating Zambia’s Diamond Jubilee of Independence!
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>November 7, 2024</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    In honor of Zambia’s 60th Independence Day, our Chipata Branch proudly donated brand-new beddings to Kapata Urban Clinic, bringing comfort to patients and supporting quality...
                  </p>
                  <a href="/celebrating-zambia-s-diamond-jubilee-of-independence">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/izb-40-creativity-unleashed">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider6} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/izb-40-creativity-unleashed">
                      IZB@40: CREATIVITY UNLEASHED
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>October 2, 2024</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    We are thrilled to announce the winners of the IZB@40: CREATIVITY UNLEASHED social media competition held in partnership with the National Arts Council of Zambia. A big...
                  </p>
                  <a href="/izb-40-creativity-unleashed">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-6 hide-on-tablet">
              <div
                className="single-blog-style1 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <a href="/indo-zambia-bank-supports-chawama-constituency-development">
                  <div className="img-holder">
                    <div className="inner">
                      <img className="imgresize" src={izbNewsSlider20} alt="" />

                      <div className="overlay-icon"></div>

                    </div>
                  </div>
                </a>
                <div className="text-holder">
                  <h3 className="blog-title mt-0 text-left">
                    <a href="/indo-zambia-bank-supports-chawama-constituency-development" style={{ textTransform: "none" }}>
                      Indo Zambia Bank Supports Chawama Constituency...
                    </a><br />
                    <span style={{ fontSize: "15px", color: "gray" }}>August 30, 2024</span>
                  </h3>
                  <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                    On 30th August 2024, Indo Zambia Bank proudly facilitated the handover of Constituency Development Funds (CDF) to beneficiaries in Chawama constituency. This initiative reflects our...
                  </p>
                  <a href="/indo-zambia-bank-supports-chawama-constituency-development">
                    <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                      Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                    </h5>
                  </a>
                  <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                </div>
              </div>
            </div>


            <div className="test show-on-tablet news-slider-list-slider row align-items-center">
              <Slider {...settings}>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="https://youtu.be/7HwteoItStI" target="_blank">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider33} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="https://youtu.be/7HwteoItStI" target="_blank">
                          Indo Zambia Bank – Landmark CSR Project, delivers...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>November 18, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank has reaffirmed its commitment to national development through major CSR investments in the health sector. With donations totaling over K1.9 million, we equipped the Zambia Flying Doctor Service...
                      </p>
                      <a href="https://youtu.be/7HwteoItStI" target="_blank">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider32} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital">
                          Indo Zambia Bank officially hands over essential...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>November 17, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank proudly reaffirmed its commitment to healthcare by officially handing over essential medical equipment to the Ministry of Health at Ndola Teaching Hospital (NTH) valued at over ZMW 422,000...
                      </p>
                      <a href="/indo-zambia-bank-donates-medical-equipment-to-ndola-teaching-hospital">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider31} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia">
                          Indo Zambia Bank proudly reaffirmed its commitment...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>November 15, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank is proud to have officially handed over a fully furbished and equipped state-of-the-art Theatre unit and Dental unit, valued at over ZMW 1 million, to The Ministry of Health at The Zambia Flying Doctors...
                      </p>
                      <a href="/indo-zambia-bank-proudly-reaffirmed-its-commitment-to-healthcare-in-zambia">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-partners-with-zambia-airways-to-elevate-premier-banking-experience">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider30} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-partners-with-zambia-airways-to-elevate-premier-banking-experience">
                          Indo Zambia Bank Partners with Zambia Airways to...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>November 12, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank has signed a Memorandum of Understanding with Zambia Airways, introducing exclusive flight discounts for Premier Banking customers across all routes. The partnership aims to enhance...
                      </p>
                      <a href="/indo-zambia-bank-partners-with-zambia-airways-to-elevate-premier-banking-experience">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/ba-kopala-platinum-sponsor-2025-zaffico-marathon">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider29} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/ba-kopala-platinum-sponsor-2025-zaffico-marathon">
                          Ba Kopala! Celebrating endurance, community and...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>November 09, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank is proud to have been the Platinum Sponsor of the 2025 ZAFFICO Marathon held in Ndola. The event brought together over 1,000 runners from across the country in a celebration of fitness...
                      </p>
                      <a href="/ba-kopala-platinum-sponsor-2025-zaffico-marathon">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/izb-southern-province-mou-for-farmer-loans">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider28} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/izb-southern-province-mou-for-farmer-loans">
                          Indo Zambia Bank signed a Memorandum of...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>October 16, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        During Day two of the Southern Province Expo 2025, our Managing Director, Mr. Brajesh Kumar Singh, participated in a panel discussion themed “Climate Smart Agriculture and Livestock Value Chain.”
                      </p>
                      <a href="/izb-southern-province-mou-for-farmer-loans">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider27} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo">
                          Indo Zambia Bank Exhibits at the 2025 Southern Province...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>October 15, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank was honoured to be a Bronze Sponsor and participant at the Southern Province Expo 2025, held in Livingstone under the theme “Unlocking Investment Opportunities for Socio-Economic Transformation...
                      </p>
                      <a href="/indo-zambia-bank-exhibits-at-the-2025-southern-province-expo">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-2025">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider26} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-2025">
                          Indo Zambia Bank proudly participated in the inaugural...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>October 14, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Last week, Indo Zambia Bank proudly participated in the inaugural Higher Education Indaba 2025 held in Livingstone, organized by the Higher Education Authority and officiated by The Minister of Education...
                      </p>
                      <a href="/indo-zambia-bank-proudly-participated-in-the-inaugural-higher-education-indaba-2025">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/the-italian-school-of-lusakas-educational-tour-of-indo-house-our-corporate-head-office">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider25} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/the-italian-school-of-lusakas-educational-tour-of-indo-house-our-corporate-head-office">
                          The Italian School of Lusaka's educational tour of Indo...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>October 10, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        As part of Customer Service Week, Indo Zambia Bank was delighted to host pupils from The Italian School Of Lusaka for an educational tour of Indo House, our Corporate Head Office. The visit provided the pupils with valuable...
                      </p>
                      <a href="/the-italian-school-of-lusakas-educational-tour-of-indo-house-our-corporate-head-office">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider24} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance">
                          IZB launches Indo Dairy Production Finance Scheme...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>October 4, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank (IZB) has launched the Indo Dairy Production Finance Scheme and Indo Dairy Development Finance Scheme in Magoye, Southern Province.
                        Southern Province Permanent Secretary...
                      </p>
                      <a href="/izb-launches-indo-dairy-production-finance-scheme-and-indo-dairy-development-finance">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/idc-intra-group-market-place">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider23} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/idc-intra-group-market-place">
                          IDC Intra Group Market Place! <br />
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>October 2, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank proudly participated in the Industrial Development Corporation (IDC) Intergroup Marketplace, held on 1st October 2025 at the Mulungushi International Conference Centre.
                      </p>
                      <a href="/idc-intra-group-market-place">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider22} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget">
                          IZB and MOFNP partner to host the National...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>September 29, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank (IZB) Managing Director, Mr. Brajesh Kumar Singh, has reaffirmed the Bank’s unwavering commitment to Zambia’s economic growth and development, speaking during his opening remarks at the National...
                      </p>
                      <a href="/izb-and-mofnp-partner-to-host-the-national-symposium-on-2026-budget">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-commits-k665-million-to-zescos-green-energy-initiative-in-chadiza">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider21} alt="" />
                          <div className="overlay-icon"></div>
                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-commits-k665-million-to-zescos-green-energy-initiative-in-chadiza">
                          Indo Zambia Bank Commits K66.5 Million to ZESCO’s...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>September 24, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank (IZB) and @zesco.zm Limited have signed a landmark K66.5 million Facility Agreement under the Bank of Zambia’s Stability and Resilience Facility (SRF), marking a crucial step in strengthening Zambia’s...
                      </p>
                      <a href="/indo-zambia-bank-commits-k665-million-to-zescos-green-energy-initiative-in-chadiza">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>
                {/*  */}

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/empowering-communities-with-cdf-loans">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider18} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/empowering-communities-with-cdf-loans">
                          Empowering Communities with CDF Loans
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>August 8, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank proudly handed over Constituency Development Fund loans to beneficiaries in Milenge Constituency. This support will help local entrepreneurs and communities grow, create...
                      </p>
                      <a href="/empowering-communities-with-cdf-loans">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="https://www.youtube.com/watch?v=yhg1fBLQTOs" target="_blank">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider16} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="https://www.youtube.com/watch?v=yhg1fBLQTOs" target="_blank">
                          Indo Zambia Bank stand at the 97th Agricultural...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>August 06, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        In case you missed it, our stand coverage of the 97th Agricultural and Commerical show.<br /><br /><br />
                      </p>
                      <a href="https://www.youtube.com/watch?v=yhg1fBLQTOs" target="_blank">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/supporting-chembe-future-with-youth-women-empowerment">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider17} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/supporting-chembe-future-with-youth-women-empowerment">
                          Supporting Chembe’s Future with Youth & Women...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>July 31, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        On 31st July 2025, Indo Zambia Bank proudly handed over the Chembe Youth, Women, and Empowerment Grant to deserving beneficiaries. This initiative fuels entrepreneurship, strengthens communities...
                      </p>
                      <a href="/supporting-chembe-future-with-youth-women-empowerment">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-and-zaffico-sign-k200-million-funding-agreement">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider15} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-and-zaffico-sign-k200-million-funding-agreement">
                          Indo Zambia Bank and Zaffico Sign K200 Million...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>June 26, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Yesterday, Indo Zambia Bank and the Zambia Forestry and Forest Industries Corporation (ZAFFICO) signed a landmark K200 million funding agreement under the Bank of Zambia’s Stability and Resilience...
                      </p>
                      <a href="/indo-zambia-bank-and-zaffico-sign-k200-million-funding-agreement">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/izb-hands-over-constituency-development-funds-in-solwezi">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider19} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/izb-hands-over-constituency-development-funds-in-solwezi">
                          IZB Hands Over Constituency Development Funds...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>June 11, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        On 11th June 2025, Indo Zambia Bank proudly handed over Constituency Development Funds (CDF) to beneficiaries under the Solwezi Council. This initiative is part of our commitment to Supporting You...
                      </p>
                      <a href="/izb-hands-over-constituency-development-funds-in-solwezi">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/branch-tour-of-international-school-of-lusaka-at-our-corporate-head-office">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider14} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/branch-tour-of-international-school-of-lusaka-at-our-corporate-head-office">
                          Branch tour of International School of Lusaka...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>May 19, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        At Indo Zambia Bank, we do not just offer banking, we empower financial futures. We were delighted to host Year Four pupils from the International School of Lusaka at our Corporate Head Office...
                      </p>
                      <a href="/branch-tour-of-international-school-of-lusaka-at-our-corporate-head-office">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider13} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                          Indo Zambia Bank is proud to be awarded Best Customer...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>May 13, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        This past Friday, we were honoured to attend the 28th Annual Zambia Institute of Marketing Excellence Conference and Awards Gala Dinner held in Livingstone. At the same event, Indo Zambia Bank was awarded...
                      </p>
                      <a href="/indo-zambia-bank-is-proud-to-be-awarded-best-customer-service-organisation-of-the-year-private-sector-2024">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider12} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                          Indo Zambia Bank Signs a (MoU) with the (DAZ)
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>April 23, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank is pleased to announce the signing of a Memorandum of Understanding (MoU) with the Dairy Association of Zambia (DAZ) for the provision of loan facilities to its members. Through this....
                      </p>
                      <a href="/indo-zambia-bank-signs-a-memorandum-of-understanding-mou-with-the-dairy-association-of-zambia-daz">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider11} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                          Coffee & Cars with Indo Zambia Bank, in partnership...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>April 14, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        This past weekend we partnered with Southern Cross Motors for an unforgettable Coffee & Cars experience! Guests had the unique opportunity to test drive some of the world’s finest motor vehicle brands...
                      </p>
                      <a href="/coffee-cars-with-indo-zambia-bank-in-partnership-with-southern-cross-motors">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="https://www.youtube.com/watch?v=WFhRVyp-Z2U" target="_blank">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider9} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="https://www.youtube.com/watch?v=WFhRVyp-Z2U" target="_blank">
                          Zambia Financial Literacy Week 2025
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>April 01, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>

                        This year, we took financial literacy beyond banking, reaching communities across all 10 provinces of Zambia.
                        At Indo Zambia Bank, we believe that financial literacy is the key to a brighter future.
                      </p>
                      <a href="https://www.youtube.com/watch?v=WFhRVyp-Z2U" target="_blank">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/izb-40th-annual-general-meeting">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider10} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/izb-40th-annual-general-meeting">
                          IZB 40th Annual General Meeting
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>April 01, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>

                        Last Friday, the bank held its 40th Annual General Meeting, followed by a press briefing where our Board Chairman, Dr. Michael Gondwe, shared highlights of the Bank’s 2024 financial performance...
                      </p>
                      <a href="/izb-40th-annual-general-meeting">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider8} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options">
                          Indo Zambia Bank Partners with Action Auto...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>March 03, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>

                        Indo Zambia Bank is pleased to announce a strategic partnership with Action Auto Zambia Limited, an authorized Isuzu vehicles dealer. This collaboration extends the Indo Vehicle Finance program to the general...
                      </p>
                      <a href="/indo-zambia-bank-partners-with-action-auto-zambia-to-extend-vehicle-financing-options">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider1} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public">
                          Indo Zambia Bank And Southern Cross Motors...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>Jan 29, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>

                        Indo Zambia Bank has partnered with @southerncrossmotors to provide motor vehicle financing to the general public through a Memorandum of Understanding signed yesterday...
                      </p>
                      <a href="/indo-zambia-bank-and-southern-cross-motors-ltd-partner-to-offer-vehicle-finance-to-the-public">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider2} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development">
                          Indo Zambia Bank To Fund Prospective Home...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>Jan 27, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        On 20th January 2025, Indo Zambia Bank (IZB) signed a memorandum of understanding with The Hills Property Development to revolutionise homeownership opportunities in zambia. Through this...
                      </p>
                      <a href="/indo-zambia-bank-to-fund-prospective-home-owners-in-the-hills-property-development">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider3} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships">
                          Indo Zambia Bank And Zambia Air Force...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>Jan 21, 2025</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>

                        On 20th January 2025, Indo Zambia Bank Managing Director, Mr. Brajesh Kumar Singh accompanied by the General Manager Mr. Godwin C. Ngoma and his delegation, paid a courtesy ...
                      </p>
                      <a href="/indo-zambia-bank-and-zambia-air-force-forging-stronger-partnerships">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-has-signed-an-agreement-with-frontclear">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider4} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-has-signed-an-agreement-with-frontclear">
                          Indo Zambia Bank has signed an agreement...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>November 29, 2024</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Recognizing that Money Markets are central to the functioning of financial systems, Indo Zambia Bank has signed an agreement with Frontclear enabling the Bank to participate...
                      </p>
                      <a href="/indo-zambia-bank-has-signed-an-agreement-with-frontclear">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/izb-40-creativity-unleashed">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider6} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/izb-40-creativity-unleashed">
                          IZB@40: CREATIVITY UNLEASHED
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>October 2, 2024</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        We are thrilled to announce the winners of the IZB@40: CREATIVITY UNLEASHED social media competition held in partnership with the National Arts Council of Zambia. A big...
                      </p>
                      <a href="/izb-40-creativity-unleashed">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/celebrating-zambia-s-diamond-jubilee-of-independence">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider7} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/celebrating-zambia-s-diamond-jubilee-of-independence">
                          Celebrating Zambia’s Diamond Jubilee of Independence!
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>November 7, 2024</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        In honor of Zambia’s 60th Independence Day, our Chipata Branch proudly donated brand-new beddings to Kapata Urban Clinic, bringing comfort to patients and supporting quality...
                      </p>
                      <a href="/celebrating-zambia-s-diamond-jubilee-of-independence">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-is-here-at-cop29">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider5} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-is-here-at-cop29">
                          Indo Zambia Bank is here at COP29!
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>November 13, 2024</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        Indo Zambia Bank was proud to attend the COP29 UN Climate Change Conference in Baku, Azerbaijan. Staying at the forefront of climate action, we are committed to innovative ...
                      </p>
                      <a href="/indo-zambia-bank-is-here-at-cop29">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 col-lg-4">
                  <div
                    className="single-blog-style1 wow fadeInUp"
                    data-wow-delay="00ms"
                    data-wow-duration="1500ms"
                  >
                    <a href="/indo-zambia-bank-supports-chawama-constituency-development">
                      <div className="img-holder">
                        <div className="inner">
                          <img className="imgresize" src={izbNewsSlider20} alt="" />

                          <div className="overlay-icon"></div>

                        </div>
                      </div>
                    </a>
                    <div className="text-holder">
                      <h3 className="blog-title mt-0 text-left">
                        <a href="/indo-zambia-bank-supports-chawama-constituency-development">
                          Indo Zambia Bank Supports Chawama Constituency...
                        </a><br />
                        <span style={{ fontSize: "15px", color: "gray" }}>August 30, 2024</span>
                      </h3>
                      <p style={{ marginBottom: "0rem", paddingTop: "12px" }}>
                        On 30th August 2024, Indo Zambia Bank proudly facilitated the handover of Constituency Development Funds (CDF) to beneficiaries in Chawama constituency. This initiative reflects our...
                      </p>
                      <a href="/indo-zambia-bank-supports-chawama-constituency-development">
                        <h5 style={{ fontWeight: "500", color: "#9E1B1E", textAlign: "right", paddingBottom: "16px", paddingTop: "16px" }}>
                          Read More <AiOutlineArrowRight size={21} className="me-1 pb-1" />
                        </h5>
                      </a>
                      <hr style={{ color: "#9E1B1E", margin: "0rem 0" }} />
                    </div>
                  </div>
                </div>

              </Slider>
            </div>

          </div>
        </div>
      </section>

      <div className="col-xl-12 justify-content-center"></div>
      <AllAcountsSection />
    </>
  );
};

export default LatestNews;
